import gql from 'graphql-tag';

export default gql`
  mutation updateStudentLevelUserMutation($records: [UpdateStudentLevelUserInput], $courseCategoryId: MongoID!) {
    updateStudentLevelUserMutation(records: $records, courseCategoryId: $courseCategoryId) {
      status
    }
  }
`;
